<template lang="pug">
v-container.pt-10.pb-16(v-if="elfsightKey")
  .text-h4.font-weight-bold.text-center.mb-6 SIGA NOSSO INSTAGRAM
  v-sheet.mx-auto(max-width="1150px")
    instagram(:elfsight-key="elfsightKey")
</template>

<script>
import Instagram from "@/components/widgets/Instagram.vue";

export default {
  computed: {
    elfsightKey() {
      return this.$rest("informations").item.elfsight_key;
    },
  },
  components: {
    Instagram,
  },
};
</script>
